import _ from "lodash";
import moment from "moment";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import mozillaPdf from "pdfjs-dist";
import * as actions from "./actions";
import pagePreloaderManager from "../../../services/managers/page-preloader";
import datetimeManager from "../../../services/managers/datetime";
import { ZONES, CHARTS, DATE_FORMAT, SELECT_EMPTY_VALUE } from "../../../services/managers/constants";
import {
  MSG_DOWNLOAD_LOADING,
  MSG_DOWNLOAD_IMAGE_TITLE,
  MSG_DOWNLOAD_IMAGE_SUB_TITLE,
  MSG_DOWNLOAD_IMAGE_TOOL_URL,
  MSG_DOWNLOAD_IMAGE_COPYRIGHT
} from "../../../services/managers/string-literals";
import appDataTransformer from "../../../services/transformers/app-data";
import { showHideElementsByClassName } from "../../../services/managers/dom";
import cmeGroupLogo from '../../../assets/images/cme_group_logo.png';

function toDataURL(src,callback){
  var img = new Image();
  // Add CORS approval to prevent a tainted canvas
  img.crossOrigin = 'Anonymous';
  img.onload = function() {
    var canvas = document.createElement('CANVAS');
    // Create a 2d context
    var ctx = canvas.getContext('2d');
    // Resize the canavas to the original image dimensions
    canvas.height = this.naturalHeight;
    canvas.width =this.naturalWidth;
    // Draw the image to a canvas
    ctx.drawImage(this, 0, 0);
    // Convert the canvas to a data url
   let imageUrl = canvas.toDataURL('image/png');
    // Return the data url via callback
    callback(imageUrl);
    // Mark the canvas to be ready for garbage collection
    canvas = null;
  }
  img.src=src;
}

export const onDownloadClick = (payload) => (dispatch, getState) => {
  pagePreloaderManager.show(MSG_DOWNLOAD_LOADING);
  
  setTimeout(() => {
    let cmeGroupLogoUrl='';
    toDataURL(cmeGroupLogo, function(imageUrl){
      cmeGroupLogoUrl = imageUrl;
    });
    let state = getState();
    let productObj = _.find(appDataTransformer.getAllProducts(), { ProductCode: state.analytics.selectedProduct });
    let zoneObj = _.find(ZONES, { Code: state.analytics.selectedZone });
    let fromDate = datetimeManager.getWholeDateTime(state.analytics.selectedDateRangeFrom, undefined, DATE_FORMAT);
    let toDate = datetimeManager.getWholeDateTime(state.analytics.selectedDateRangeTo, undefined, DATE_FORMAT);
    let primaryChartObj = _.find(CHARTS, { Code: state.analytics.chartWhiteboards[payload.whiteboardIndex].selectedPrimaryChart });
    let selectedComparisonChartObj = null;

    let chartMetaText = {
      analysis: "",
      filters: productObj.Product + " / " + fromDate + " to " + toDate + " / " + zoneObj.Name + " (" + zoneObj.Timing + ")"
    };

    if (state.analytics.chartWhiteboards[payload.whiteboardIndex].selectedComparisonChart !== SELECT_EMPTY_VALUE) {
      selectedComparisonChartObj = _.find(CHARTS, { Code: state.analytics.chartWhiteboards[payload.whiteboardIndex].selectedComparisonChart });
      chartMetaText.analysis = primaryChartObj.Name + " vs. " + selectedComparisonChartObj.Name;
    } else {
      chartMetaText.analysis = primaryChartObj.Name;
    }

    let pdfDocument = null;

    // Hide Enlarge links while downloading
    showHideElementsByClassName("hide", "btn--enlarge");

    // Set width for image being downloaded
    const imageWidth = document.getElementById("chartWhiteboardDrawingDownload" + payload.whiteboardIndex).offsetWidth + 40;

    domtoimage
      .toJpeg(document.getElementById("chartWhiteboardDrawingDownload" + payload.whiteboardIndex), {
        quality: 1.0, width: imageWidth
      })
      .then(function(dataUrl) {
        let image = new Image();
        image.src = dataUrl;
        image.addEventListener("load", function() {
          let docWidth = 595; // Width of A4 page (in points)
          let docHeight = 0;

          let imageHeight = this.naturalHeight * 0.75; // Height (in points)
          let imageWidth = this.naturalWidth * 0.75; // Width (in points)

          let metaTextHeight = 80;
          let copyrightTextHeight = 20;

          if (imageWidth > docWidth) {
            // Image's width is larger than PDF document's width
            // Resize image, while maintaining aspect ratio
            let aspectRatio = imageWidth / imageHeight;
            imageHeight = Math.round(docWidth / aspectRatio);
            imageWidth = docWidth;
          }

          docHeight = metaTextHeight + copyrightTextHeight + imageHeight + 15;

          // Start generating a PDF file

          pdfDocument = new jsPDF(docWidth >= docHeight ? "l" : "p", "pt", [docWidth, docHeight]);

          pdfDocument.setFont("helvetica");
          pdfDocument.setFontStyle("normal");
          pdfDocument.setFontSize(14);
          pdfDocument.text(MSG_DOWNLOAD_IMAGE_TITLE, 15, 20);
          pdfDocument.setFontSize(10);
          pdfDocument.text(MSG_DOWNLOAD_IMAGE_SUB_TITLE+MSG_DOWNLOAD_IMAGE_TOOL_URL, 15, 30);
          pdfDocument.addImage(cmeGroupLogoUrl, "JPEG",docWidth-100,-5,100,50);
          pdfDocument.line(0, 40, docWidth, 40);
          pdfDocument.setFontStyle("bold");
          pdfDocument.setFontSize(10);
          pdfDocument.text([chartMetaText.analysis, chartMetaText.filters], 15, 60);

          pdfDocument.addImage(dataUrl, "JPEG", 0, metaTextHeight, imageWidth, imageHeight);

          let copyrightY = metaTextHeight + imageHeight + 15;
          pdfDocument.line(0, copyrightY, docWidth, copyrightY);
          pdfDocument.setFontStyle("normal");
          pdfDocument.setFontSize(8);
          pdfDocument.text("© " + moment().year() + " " + MSG_DOWNLOAD_IMAGE_COPYRIGHT, 15, copyrightY + 12);

          // Start converting a PDF file to Image

          let blob = pdfDocument.output("blob");
          let fileReader = new FileReader();

          fileReader.onload = function() {
            mozillaPdf.getDocument(fileReader.result).then(
              function getPdf(pdf) {
                // Fetching the first page of the pdf
                pdf.getPage(1).then(
                  function getPage(page) {
                    // Set image scale (larger scale = more zoom level)
                    let scale = 1.5;
                    let viewport = page.getViewport(scale);

                    // Create canvas
                    let canvas = document.createElement("canvas");
                    let context = canvas.getContext("2d");
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    let task = page.render({ canvasContext: context, viewport: viewport });
                    task.promise
                      .then(function() {
                        let link = document.createElement("a");
                        link.download = MSG_DOWNLOAD_IMAGE_TITLE + " - " + chartMetaText.analysis + " - " + moment().format(DATE_FORMAT) + ".jpeg";
                        link.href = canvas.toDataURL("image/jpeg", 1.0);
                        link.click();
                        dispatch({ type: actions.ON_DOWNLOAD_CLICK, payload: { ...payload } });
                      })
                      .catch(function(error) {
                        console.error("Catch Error", typeof error, error, error.response);
                        dispatch({ type: actions.ON_DOWNLOAD_CLICK, payload: { ...payload } });
                      });
                  },
                  function(error) {
                    console.error("Catch Error", typeof error, error, error.response);
                    dispatch({ type: actions.ON_DOWNLOAD_CLICK, payload: { ...payload } });
                  }
                );
              },
              function(error) {
                console.error("Catch Error", typeof error, error, error.response);
                dispatch({ type: actions.ON_DOWNLOAD_CLICK, payload: { ...payload } });
              }
            );
          };
          fileReader.readAsArrayBuffer(blob);
        });
        showHideElementsByClassName("show", "btn--enlarge");
      })
      .catch(function(error) {
        console.error("Catch Error", typeof error, error, error.response);
        showHideElementsByClassName("show", "btn--enlarge");
        dispatch({ type: actions.ON_DOWNLOAD_CLICK, payload: { ...payload } });
      });
  }, 1000);
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-download/action-creators.js